import { Shield } from 'lucide-react';

import type { UserRegionRef } from '../userViewModel';

interface RegionChipProps {
  region: UserRegionRef;
  locked?: boolean;
}

export default function RegionChip({ region, locked }: RegionChipProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 h-5 px-2 rounded-md text-[10.5px] font-semibold whitespace-nowrap border ${
        locked
          ? 'text-stone-400 bg-stone-100 border-stone-200'
          : 'text-moss-700 bg-[#EAF3DE] border-moss-200'
      }`}
    >
      {region.code}
      {locked && <Shield size={10} />}
    </span>
  );
}
